import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32508426"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-dialog__dialog" }
const _hoisted_2 = { class: "dialog__skip-intro" }
const _hoisted_3 = {
  key: 0,
  class: "dialog__countdown"
}

import { getCharacterName, getDialog } from '@/utils/dialogHelper';
import DialogImage from '@/features/DialogImage.vue';
import StartRoundCountdown from '@/features/StartRoundContdown.vue';
import { computed, ref } from 'vue';
import router from '@/router';
import GameHeader from '@/features/GameHeader.vue';
import ShowWordByWord from '@/components/ShowWordByWord.vue';
import { useRoute } from 'vue-router';

import { ROUTES } from '@/router/routes';
import { isPhone } from '@/utils/responsiveHelper';
import { useGameStore } from '@/stores/gameStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameDialogView',
  setup(__props) {

const gameStore = useGameStore();
const route = useRoute();
const isEndView = Boolean(route.params.isEnd);

const dialog = getDialog(isEndView);

const round = ref(0);
const showCountDown = ref(false);

const text = ref(dialog.dialog[0]);

const isForgerSpeaking = computed(() => round.value === 1);

const getCharacterImage = computed(() => {
  if (!isPhone()) {
    if (isEndView && round.value === 2) {
      return dialog.characterImg2;
    } else {
      return dialog.characterImg;
    }
  } else {
    switch (round.value) {
      case 0:
        return dialog.characterImg;
      case 1:
        return undefined;
      case 2:
        return isEndView ? dialog.characterImg2 : dialog.characterImg;
      case 3:
        return dialog.forgerImg;
      default:
        return undefined;
    }
  }
});

const characterName = computed(() =>
  getCharacterName(isEndView, dialog, round.value)
);

const getForgerImage = () => {
  return isEndView &&
    ((round.value === 2 && !gameStore.survived) ||
      (round.value >= 1 && gameStore.survived))
    ? dialog.forgerImg
    : undefined;
};

const showNextDialog = () => {
  window.setTimeout(() => {
    if (round.value < 2) {
      updateDialogSpeaker();
    } else if (!isEndView) {
      showCountDown.value = true;
    } else {
      router.push(ROUTES.GAME_OVER);
    }
  }, 1000);
};

function updateDialogSpeaker() {
  round.value++;

  text.value = dialog.dialog[round.value];
}

function skipButtonRoute() {
  if (isEndView) {
    router.push(ROUTES.GAME_OVER);
  } else {
    router.push(ROUTES.PLAY);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GameHeader),
    _createVNode(DialogImage, {
      imageValue: getCharacterImage.value,
      firstImage: "",
      class: _normalizeClass({
      '--active': !isForgerSpeaking.value || _unref(isPhone)()
    })
    }, null, 8, ["imageValue", "class"]),
    _createVNode(DialogImage, {
      imageValue: getForgerImage(),
      class: _normalizeClass({ '--active': isForgerSpeaking.value, secondImage: true })
    }, null, 8, ["imageValue", "class"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("p", {
            class: "game-dialog__dialog-speaker",
            key: characterName.value
          }, _toDisplayString(_unref(getCharacterName)(_unref(isEndView), _unref(dialog), round.value)), 1))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            style: {"text-align":"center"},
            key: text.value
          }, [
            _createVNode(ShowWordByWord, {
              text: text.value,
              "onShowWordByWord:finished": showNextDialog
            }, null, 8, ["text"])
          ]))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (skipButtonRoute()))
        }, "Skip dialog")
      ])
    ]),
    (showCountDown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(StartRoundCountdown)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})